<eda-dialog2 width="80vw" height="80vh" [header]="title" (apply)="saveChartConfig()" (close)="closeChartConfig()">
  <div content class="flex flex-col md:flex-row flex-1 overflow-hidden h-[70vh]">

    <div class="flex items-center justify-between w-full p-2 border-b w-[30rem]">
      <label i18n="@@showField" class="font-medium text-gray-700">
        Mostrar campo de origen
      </label>

      <label class="relative inline-flex items-center cursor-pointer">
        <input type="checkbox" [(ngModel)]="showOriginField" class="sr-only peer">
        <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--corporate-primary)] rounded-full
             peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
             peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px]
             after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all
             peer-checked:bg-[var(--corporate-primary)]">
        </div>
      </label>
    </div>

    @if(config.hierarchyLabels.length > 0){
      <div class="card picklist-card justify-items-center"
        [ngClass]="{'picklist-collapsed': !sourceProducts?.length && !targetProducts?.length}">
        <p-pickList [source]="sourceProducts" [target]="targetProducts" sourceHeader="Etiquetas de jerarquía"
          targetHeader="Etiquetas de hojas" [dragdrop]="true" [responsive]="true" [sourceStyle]="{ width: '30rem' }"
          [targetStyle]="{ width: '30rem' }" breakpoint="1400px" [showSourceControls]="false" [showTargetControls]="false"
          class="picklist-gris-elegante">
          <ng-template let-product pTemplate="item">
            <div
              class="flex flex-wrap items-center p-3 gap-2 bg-gray-50 hover:bg-gray-100 rounded-md border border-gray-200 transition-all duration-200">
              <div class="flex-1 flex flex-col">
                <span class="font-medium text-gray-700">{{ product }}</span>
              </div>
            </div>
          </ng-template>
        </p-pickList>
      </div>
    }

  </div>

  <div footer>
    <div class="flex justify-end p-2 border-t gap-1.5">
      <button class="cancel-button" (click)="closeChartConfig()">
        <i class="fa fa-times"></i>
        <span i18n="@@cancelarBtn">Cancelar</span>
      </button>
      <button class="confirm-button" (click)="saveChartConfig()">
        <i class="fa fa-check"></i> <span i18n="@@guardarBtn">Confirmar</span>
      </button>
    </div>
  </div>
</eda-dialog2>